<div *ngIf="supportedLangs.length > 0">
	<div *ngIf="display==='button'">
		<button
			mat-raised-button
			*ngFor="let lang of supportedLangs"
			class="bh-localization-button"
			(click)="selectLang(lang)"
			[class.btn-primary]="isCurrentLang(lang.value)"
		>
			<sdp-icon [icon]="lang.icon"></sdp-icon>{{ lang.display }}
		</button>
	</div>
	<div *ngIf="display==='dropdown'">
		<button
			mat-button
			[matMenuTriggerFor]="menu"
		>{{ selectedLang.display }}
			<sdp-icon [icon]="dropdownIcon"></sdp-icon>
		</button>
		<mat-menu #menu="matMenu">
			<button
				*ngFor="let lang of supportedLangs"
				(click)="selectLang(lang)"
				mat-menu-item
			>{{ lang.display }}</button>
		</mat-menu>
	</div>
</div>